import RNToast, { ToastConfig } from 'react-native-toast-message';
import React from 'react';
import Toast from './Toast';

const toastConfig: ToastConfig = {
  success: (props) => {
    return <Toast {...props} type="success" />;
  },
  feature: (props) => {
    return <Toast {...props} type="feature" />;
  },
  info: (props) => {
    return <Toast {...props} type="info" />;
  },
  error: (props) => {
    return <Toast {...props} type="error" />;
  },
  warning: (props) => {
    return <Toast {...props} type="warning" />;
  },
};

const ToastContainer = () => {
  return <RNToast config={toastConfig} />;
};

export default ToastContainer;
